import { createValidator, maxLength, required, richTextMaxLength } from 'util/validation'

import { antropometriaValidator } from '../components/MedicoesPanel/validator-antropometria'
import { sinaisVitaisAccordionValidator } from '../components/MedicoesPanel/validator-sinaisVitais'
import { agendarConsultaAvulsaValidator } from '../detail/soap/finalizacao/validator/validator-agendamento'
import { EscutaInicialState } from './model-escutaInicial'
import { MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

export const escutaInicialValidator = (
  isPreAtendimento: boolean,
  getServerTimeNow: () => Date,
  showHorarioFinal: boolean = false
) =>
  createValidator<EscutaInicialState>(
    {
      motivoConsulta: motivoConsultaValidator,
      sinaisVitais: sinaisVitaisAccordionValidator,
      antropometria: antropometriaValidator,
      agendamentoConsulta: agendarConsultaAvulsaValidator(getServerTimeNow, showHorarioFinal),
    },
    (values: EscutaInicialState, errors) => {
      if (!isPreAtendimento) errors.classificacaoRisco = required(values.classificacaoRisco)
      if (maxLength(20)(values.procedimentos))
        errors.procedimentos = 'O número máximo de procedimentos em um atendimento é 20'

      return errors
    }
  )

const motivoConsultaValidator = createValidator<MotivoConsultaFormModel>({
  ciap: [required],
  texto: [richTextMaxLength(4000)],
})
